import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();
  const [submissionMessage, setSubmissionMessage] = useState(""); // State for submission message

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_bhkz0pp",
        "template_nijxoi5",
        form.current,
        "PDFw3ft2-GJLPYJAX"
      ) // Replace with your service, template, and user ID
      .then(
        (result) => {
          console.log(result.text);
          setSubmissionMessage("Email sent successfully"); // Update submission message
        },
        (error) => {
          console.log(error.text);
          setSubmissionMessage("Error sending email"); // Update submission message
        }
      );
  };

  return (
    <div className="container contact-container">
      <h1>Contact Us</h1>
      <form className="contact-form" ref={form} onSubmit={sendEmail}>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Name:
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="to_name"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email:
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="from_name"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="message" className="form-label">
            Message:
          </label>
          <textarea
            className="form-control"
            id="message"
            name="message"
            rows="4"
          />
        </div>
        <button type="submit" value="Send" className="btn btn-primary">
          Submit
        </button>
      </form>
      {submissionMessage && <div className="mt-3">{submissionMessage}</div>}
    </div>
  );
};

export default Contact;



